export default __webpack_public_path__ + "static/media/icon-dashboard.69339521.svg";